<template>
  <div class="wt2-producing-panel">
    <div class="-about-description-container">
      <div class="-about-container">
        <span class="wt2-text-2xl wt2-color-negative">{{
          'producing.panelAbout' | culture
        }}</span>

        <span
          class="wt2-text-n wt2-color-negative -three-dots -space-top"
          v-if="video.title"
          :title="video.title"
        >
          {{ video.title }}
        </span>
        <span
          class="wt2-text-n wt2-color-negative -three-dots -space-top"
          v-if="videoBrandName"
          :title="videoBrandName"
          v-text="videoBrandName"
        />
        <div v-if="video.template">
          <div
            class="wt2-text-n wt2-color-negative -info"
            v-if="video.categoryNames && video.categoryNames.length"
          >
            {{ 'dashboardFilter.categories' | culture }}:
            <template v-for="(category, i) in video.categoryNames">
              <span :key="i + '_category'">{{ category }}</span>
              <span :key="i" v-if="i < video.categoryNames.length - 1">, </span>
            </template>
          </div>
        </div>
        <div v-else class="-category-and-length-container -space-top">
          <span
            class="wt2-text-n wt2-color-negative -three-dots -category"
            :title="video.mainCategory"
          >
            Category: {{ video.mainCategory }}
          </span>
          <span class="wt2-text-n wt2-color-negative -divider">|</span>
          <span class="wt2-text-n wt2-color-negative">
            Length: {{ seconds2Minutes }}
          </span>
        </div>
        <span class="wt2-text-n wt2-color-negative -three-dots -space-top">
          ID: {{ video.id }}
        </span>
      </div>

      <div class="-description-container wt2-color-negative wt2-text-n">
        <div
          class="-description"
          v-if="video.description && video.description !== ''"
        >
          {{ video.description }}
        </div>
      </div>
    </div>

    <div class="-buttons-container">
      <wt-button
        class="fluid"
        :disabled="!isUserCanCreateStories"
        type="secondary"
        :text="'generic.MAKE_COPY' | culture"
        @click="$emit('openMakeCopy', isVideoTemplate)"
      />

      <wt-button
        class="fluid -space-top-20"
        :disabled="!isUserCanCreateStories"
        type="primary"
        :text="makeNewWochitTitle"
        @click="openMakeNewWochit"
      />

      <wt-button
        class="fluid -custom -remove-hover-background -space-top -hover-blue wt2-color-negative"
        type="transparent"
        :text="'generic.GO_TO_HOME' | culture"
        @click="goToHome"
      />
    </div>
  </div>
</template>

<script>
import app from 'app';
import ProducingActionsMixin from 'v/Producing/ProducingActionsMixin.vue';

export default {
  mixins: [ProducingActionsMixin],

  props: {
    video: {
      type: Object,
      required: true,
    },
    isVideoFailed: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    seconds2Minutes() {
      return app.seconds2Minutes(this.video.videoDurationSec);
    },

    videoBrandName() {
      const selectedOrganization =
        app.rootStore.getters['user/selectedOrganization'];
      const brand = selectedOrganization.brands.find(
        (brand) =>
          brand.brandId === this.video.brandId &&
          brand.programmerId === this.video.programmerId
      );
      return brand?.name || this.video.programmerName;
    },
  },
};
</script>
